
import { Component, PropSync, Vue, Watch } from 'vue-property-decorator'
import { State } from "vuex-class"
import User from "@/types/account/user"
import { Applications } from "@/types/application/applications"

@Component({
  components: {
  }
})
export default class Navigation extends Vue {
  @PropSync('navigation', { type: Boolean, default: false }) showNavigation!: boolean;
  private mini = true
  private apps = Applications
  private baseItems = [
    { title: 'navigation.home', icon: 'home', componentName: 'home' },
    { title: 'navigation.settings', icon: 'settings', componentName: 'settings' }
  ]

  private applicationSpecificItems = {
    protocollo: [{ title: 'navigation.landlords', icon: 'person', componentName: 'landlord' }],
    timetrack: [
      { title: 'navigation.projects', icon: 'construction', componentName: 'projects' },
      { title: 'navigation.export', icon: 'file_download', componentName: 'export' }
    ],
    superuser: [
      { title: 'navigation.admin', icon: 'admin_panel_settings', componentName: 'admin' }
    ]
  }

  @State((state: any) => state.user, { namespace: 'account' })
  private user!: User;

  @State((state: any) => state.application, { namespace: 'global' })
  private app!: string;

  private clickedOutside (e: any) {
    if (e.target.className === "v-overlay__scrim" && !this.mobile) {
      this.$emit('clicked')
    }
  }

  get mobile () {
    return this.mini && (!this.$vuetify.breakpoint.mobile)
  }

  created () {
    if (this.isSuperUser) {
      this.baseItems = this.merge(this.baseItems, this.applicationSpecificItems.superuser)
    }
  }

  @Watch('user')
  private updateBaseItems () {
    if (this.isSuperUser) {
      this.baseItems = this.merge(this.baseItems, this.applicationSpecificItems.superuser)
    }
  }

  private get isSuperUser () : boolean {
    if (this.user && process.env.VUE_APP_SUPERUSER_ID && this.user.id === process.env.VUE_APP_SUPERUSER_ID) {
      return true
    }
    return false
  }

  get userLoggedIn () {
    return this.$store.getters["account/user"]
  }

  get items () {
    const app = this.$store.getters['global/application']
    if (app && app !== Applications.LINDENBERG) {
      switch (app) {
        case Applications.PROTOCOLLO:
          return this.merge(this.baseItems, this.applicationSpecificItems.protocollo)
        case Applications.TIMETRACK:
          return this.merge(this.baseItems, this.applicationSpecificItems.timetrack)
      }
    }
    return this.baseItems
  }

  merge (a: any, b: any, i = 1) {
    return a.slice(0, i).concat(b, a.slice(i))
  }

  private goToPage (componentName: string) {
    this.mini = true
    if (componentName === 'home') {
      if (this.app === this.apps.LINDENBERG) {
        if (this.$route.path !== '/') {
          if (!this.mobile) this.$emit('clicked')
          this.$router.push({ name: 'home' })
        }
      } else if (this.$route.name !== this.app) {
        if (!this.mobile) this.$emit('clicked')
        this.$router.push({ name: this.app })
      }
    } else {
      if (this.$router.currentRoute.name !== componentName) {
        if (!this.mobile) this.$emit('clicked')
        this.$router.push({ name: componentName })
      }
    }
  }

  private logout () {
    this.$store.dispatch("account/logout")
  }

  private get profilePicture () {
    return process.env.VUE_APP_STORAGE_BASE_URL + this.user.profilePicture
  }
}
